import React from 'react';

import ROUTES from '../data/routes';
import ClientParameters from './ClientsParameters';
import ClientFormComponent from '../components/form/client/Client';
import UsersFormComponent from '../components/form/users/Users';
import ProductsFormComponent from '../components/form/Products';
import PromotionFormComponent from '../components/form/Promotion';
import RecommendedFormComponent from '../components/form/Recommended';
import CategoryFormComponent from '../components/form/Category';
import AdminUsersFormComponent from '../components/form/AdminUsers';
import PunchOutRulesFormComponent from '../components/form/PunchOutRule';
import PunchOutN2RulesFormComponent from '../components/form/PunchOutN2Rule';
import DiscountCouponFormComponent from '../components/form/discountCouponForm';
import ProductFeedbackReasonFormComponent from '../components/form/productFeedbackReasonForm';
import TechnicalMaterialForm from '../components/form/technicalMaterialForm';
import CoursesAndTrainingForm from '../components/form/coursesAndTrainingForm';
import ProjectsDirectoryForm from '../components/form/projectsDirectoryForm';
import NotifyFormComponent from '../components/form/notifyForm';
import NotificationEmailForm from '../components/form/notificationEmailForm';
import TypeSolutionForm from '../components/form/TypeSolutionForm';
import CableCategoryForm from '../components/form/CableCategoryForm';
import TypeCoatingForm from '../components/form/TypeCoatingForm';
import ProductTelecomForm from '../components/form/ProductTelecomForm';
import SupplierTelecomForm from '../components/form/supplierTelecomForm';
import ApplicationTypeForm from '../components/form/applicationTypeForm';
import VoltageForm from '../components/form/voltageForm';
import PowerRangeForm from '../components/form/powerRangeForm';
import PowerForm from '../components/form/powerForm';
import AutomationProductsForm from '../components/form/automationProductsForm';
import BranchManagerFormComponent from '../components/form/BranchManagerForm';
import PacksFormComponent from '../components/form/PacksForm';

class FormPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    const { screenComming } = this.props.history.location;
    if (!screenComming) this.props.history.push(ROUTES.HOME);
  }

  render() {
    const { state, screenComming, item } = this.props.history.location;
    return (
      <div>
        {screenComming === 'register-solicitation' && <ClientFormComponent state={state} back={this.props.history} />}
        {screenComming === 'client' && <ClientFormComponent state={state} back={this.props.history} />}
        {screenComming === 'users' && <UsersFormComponent back={this.props.history} />}
        {screenComming === 'products' && <ProductsFormComponent back={this.props.history} productComming={item} />}
        {screenComming === 'recommended' && <RecommendedFormComponent back={this.props.history} />}
        {screenComming === 'promotion' && <PromotionFormComponent back={this.props.history} />}
        {screenComming === 'category' && <CategoryFormComponent back={this.props.history} />}
        {screenComming === 'admin-users' && <AdminUsersFormComponent back={this.props.history} />}
        {screenComming === 'punchout-rule' && <PunchOutRulesFormComponent back={this.props.history} />}
        {screenComming === 'punchout-n2-rule' && <PunchOutN2RulesFormComponent back={this.props.history} />}
        {screenComming === 'discountCoupon' && <DiscountCouponFormComponent back={this.props.history} />}
        {screenComming === 'productFeedbackReason' && <ProductFeedbackReasonFormComponent back={this.props.history} />}
        {screenComming === 'clientParameters' && <ClientParameters state={state} back={this.props.history} />}
        {screenComming === 'technicalMaterial' && <TechnicalMaterialForm state={state} back={this.props.history} />}
        {screenComming === 'coursesAndTraining' && <CoursesAndTrainingForm state={state} back={this.props.history} />}
        {screenComming === 'projectsDirectory' && <ProjectsDirectoryForm state={state} back={this.props.history} />}
        {screenComming === 'notify' && <NotifyFormComponent back={this.props.history} />}
        {screenComming === 'NotificationEmailForm' && <NotificationEmailForm back={this.props.history} />}
        {screenComming === 'typeSolution' && <TypeSolutionForm back={this.props.history} />}
        {screenComming === 'cableCategory' && <CableCategoryForm back={this.props.history} />}
        {screenComming === 'typeCoating' && <TypeCoatingForm back={this.props.history} />}
        {screenComming === 'productTelecom' && <ProductTelecomForm back={this.props.history} />}
        {screenComming === 'supplierTelecom' && <SupplierTelecomForm back={this.props.history} />}
        {screenComming === 'applicationType' && <ApplicationTypeForm back={this.props.history} />}
        {screenComming === 'voltage' && <VoltageForm back={this.props.history} />}
        {screenComming === 'powerRange' && <PowerRangeForm back={this.props.history} />}
        {screenComming === 'power' && <PowerForm back={this.props.history} />}
        {screenComming === 'automationProducts' && <AutomationProductsForm back={this.props.history} />}
        {screenComming === 'branchManager' && (
          <BranchManagerFormComponent
            back={this.props.history}
            branchManagerComming={item}
          />
        )}
        {screenComming === 'packs' && (
          <PacksFormComponent
            back={this.props.history}
            packsComming={item}
          />
        )}
      </div>
    );
  }
}

export default FormPage;
